import React from "react";
import "./styles/Home.css";

const Home = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="home-section">
      <div className="home-content">
        <div className="profile-image">
          <img src="/yassine2.jpg" alt="Yassine Mili" />
        </div>
        <h1>Yassine Mili</h1>
        <p className="title">Software Developer</p>
        <div className="cta-buttons">
          <a
            className="btn primary"
            href="https://drive.google.com/file/d/10OfqVBng_uNJVhrFaKXXSKeBp4KYFsOl/view"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download CV
          </a>
          <button className="btn secondary" onClick={scrollToContact}>
            Contact Me
          </button>
        </div>
        <div className="social-links">
          <a
            href="https://www.linkedin.com/in/mili-yassine/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://github.com/yassine-mili"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-github"></i>
          </a>
          <a
            href="https://leetcode.com/u/yassinemili100/"
            target="_blank"
            rel="noopener noreferrer"
            title="LeetCode"
          >
            <img
              src="/images/leetcode_icon.png"
              alt="LeetCode"
              className="leetcode-icon"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
